import AbstractComponent from "./abstract-component";

const createAnchorTemplate = (className, title, link, prompt, target) => {
  return (
    `<a class="${className}" href="${link}" title="${prompt}" target="${target}">${title}</a>`
  );
};

export default class AnchorComponent extends AbstractComponent {
  constructor({className = ``, title, link, prompt = ``, target = `_blank`}) {
    super();

    this._className = className;
    this._title = title;
    this._link = link;
    this._prompt = prompt;
    this._target = target;
  }

  getTemplate() {
    return createAnchorTemplate(this._className, this._title, this._link, this._prompt, this._target);
  }

  set title(data) {
    this._title = data;
    this.getElement().innerHTML = data;
  }

  set link(data) {
    this._link = data;
    this.getElement().href = data;
  }
}
